import { ReactNode } from "react";
import * as styles from "./style";

export const BlurredBackground = ({
  background,
  children
}: {
  background: ReactNode;
  children: ReactNode;
}) => {
  return (
    <div css={styles.container}>
      <div css={styles.background}>{background}</div>
      {children}
    </div>
  );
};
